import ContractInvitationsPagination from "./ContractInvitationsPagination";

export default ContractInvitationsPagination;
